import React, {Fragment} from 'react'
import "./profile.css";
import { useAuth0 } from "@auth0/auth0-react";

const Profile = () => {
    const { user, isAuthenticated, logout } = useAuth0();
    return (
        <Fragment>
            <p className="userName">Welcome <span>{user.name}</span></p>
            <button type="button" className="user-logout" onClick={() => logout({ returnTo: window.location.origin })}> Logout </button>
        </Fragment>
    )
}

export default Profile
